<template>
  <button class="hero-button-readme" @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: "HeroButtonReadme"
  }
</script>

<style lang="scss" scoped>
  .hero-button-readme {
    @include make-button-base;
    display: inline-block;
    background-color: transparent;
    color: $color-rwl-white-100;
    font-family: $font-family-rwl-base;
    box-shadow: inset 0 0 0 2px $color-rwl-white-100;
    background-color: transparent;

    &:hover {
      background-color: rgba($color-rwl-blue-100, 0.5);
    }
  }
</style>
